export const PROFILE_REQUEST = 'PROFILE_REQUEST'
export const PROFILE_RECEIVE = 'PROFILE_RECEIVE'
export const PROFILE_ERROR = 'PROFILE_ERROR'
export const PROFILE_INVALIDATE = 'PROFILE_INVALIDATE'
export const PROFILE_UPDATE_REQUEST = 'PROFILE_UPDATE_REQUEST'
export const PROFILE_UPDATE_RECEIVE = 'PROFILE_UPDATE_RECEIVE'
export const PROFILE_UPDATE_ERROR = 'PROFILE_UPDATE_ERROR'
export const PROFILE_UPDATE_STAGES_REQUEST = 'PROFILE_UPDATE_STAGES_REQUEST'
export const PROFILE_UPDATE_STAGES_RECEIVE = 'PROFILE_UPDATE_STAGES_RECEIVE'
export const PROFILE_UPDATE_STAGES_ERROR = 'PROFILE_UPDATE_STAGES_ERROR'
export const PROFILE_CLEAR_STAGES_RESULT = 'PROFILE_CLEAR_STAGES_RESULT'



// WEBPACK FOOTER //
// ./src/store/profile/actionTypes.js